import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { NavMenuImageCard } from '../../../../../../design-system/components/nav/nav-menu-image-card/NavMenuImageCard';
import { WhereToGoMenu } from '../../../../../../resources/whereToGoMenu/domain/types/whereToGoMenu';

import style from './CampaignTabContent.module.css';

type CampaignTabContentProps = {
    campaign: NonNullable<WhereToGoMenu['campaign']>;
};

export function CampaignTabContent({ campaign }: CampaignTabContentProps) {
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div className={style.tabContent}>
            {campaign.thematics.map((thematic, index) => {
                return (
                    <NavMenuImageCard
                        key={`${index}-${thematic.label}`}
                        label={thematic.label}
                        blur={false}
                        href={thematic.url}
                        target={thematic.openInNewTab ? '_blank' : undefined}
                        rel={thematic.openInNewTab ? 'noopener noreferrer' : undefined}
                        image={{
                            alt: thematic.coverImage.card_cover_mobile_retina.alt,
                            src: thematic.coverImage.card_cover_mobile_retina.url,
                            loading: 'lazy',
                            unoptimized: true,
                        }}
                        onClick={() => {
                            trackEvent((ampli, defaultProperties) => {
                                ampli.primaryNavThematicClicked({
                                    ...defaultProperties,
                                    block: 'primary_nav',
                                    card_number: index + 1,
                                    row_number: 1,
                                    thematic_slug: thematic.url,
                                    click_type: 'card',
                                    column_number: 0,
                                    thematic_group: 'campaign',
                                });
                            });
                        }}
                    />
                );
            })}
        </div>
    );
}
